export default __webpack_public_path__ + "static/events-ideas-photo-dbeb3c8272df0180a84720dbd6b9d360.jpg";